<template>
  <tr v-if="isChecked">
    <td class="checkbox" @click.self="checkTd" data-exclude-download>
      <Checkbox
        :id="checkBoxId"
        name="rank[]"
        :value="item.rank"
        :checked="checked"
        ref="checkbox"
        @change="change"
      />
    </td>
    <template v-if="item.contentType === 'html'">
      <td
        v-if="intent"
        class="l-px-0 c-text--center rank intent"
        :class="'is-' + intent.name"
      >
        <p v-if="item.isOwnSite" class="own-site">登録サイト</p>
        {{ item.rank }}
        <span class="intent-label">{{ intent.label }}</span>
        <div class="unknown-intent-message" v-if="showUnknownTooltip">
          <Tooltip size="sm">
            タイトルが日本語・英語・数字以外の特殊文字のみのため、インテントが不明となっています。
          </Tooltip>
        </div>
      </td>
      <td v-else class="l-px-0 c-text--center rank">
        <p v-if="item.isOwnSite" class="own-site">登録サイト</p>
        {{ item.rank }}
      </td>
      <td>
        <a :href="item.url" target="_blank" class="c-link--blank">{{
          item.url
        }}</a>
      </td>
      <td>
        <template v-if="item.title === null">
          <span class="exception-txt">
            タイトルを取得中です。
          </span>
        </template>
        <template v-else-if="item.title === ''">
          <span class="exception-txt">
            タイトルが指定されていません。
          </span>
        </template>
        <template v-else-if="typeof item.title === 'undefined'">
          <div class="exception-txt">
            タイトルを取得できませんでした。
            <Tooltip variant="attention">
              データの取得ができませんでした。
              原因は対象のサイトでIPアドレスのブロックなどの理由でデータを取得できなかったことが考えられます。
            </Tooltip>
          </div>
        </template>
        <template v-else-if="isOverTitleMaxLength">
          {{ item.title.substr(0, MAX_TDH_STRING_LENGTH) }}...
          <span class="c-text--neutral">{{
            `(※${MAX_TDH_STRING_LENGTH + 1}文字以上は表示しません)`
          }}</span>
        </template>
        <template v-else>
          {{ item.title }}
        </template>
      </td>
      <td>
        <template v-if="item.description === null">
          <span class="exception-txt">
            ディスクリプションを取得中です。
          </span>
        </template>
        <template v-else-if="item.description === ''">
          <span class="exception-txt">
            ディスクリプションが指定されていません。
          </span>
        </template>
        <template v-else-if="typeof item.description === 'undefined'">
          <div class="exception-txt">
            ディスクリプションが取得できませんでした。
            <Tooltip variant="attention">
              データの取得ができませんでした。
              原因は対象のサイトでIPアドレスのブロックなどの理由でデータを取得できなかったことが考えられます。
            </Tooltip>
          </div>
        </template>
        <template v-else-if="isOverDescriptionMaxLength">
          {{ item.description.substr(0, MAX_TDH_STRING_LENGTH) }}...
          <span class="c-text--neutral">{{
            `(※${MAX_TDH_STRING_LENGTH + 1}文字以上は表示しません)`
          }}</span>
        </template>
        <template v-else>
          {{ item.description }}
        </template>
      </td>
      <template v-if="isAfterHeaderStructuresReleaseDate">
        <td class="structures">
          <div
            v-if="
              item.headerStructures &&
                item.headerStructures.length !== 0 &&
                isBtn
            "
            class="structures-btn"
          >
            <button
              type="button"
              class="c-btn c-btn--structures"
              @click="toggleChildrenAll"
            >
              構造をすべて表示
            </button>
          </div>
          <template
            v-if="
              item.headerStructures === null ||
                (item.headerStructures.length === 0 &&
                  item.description === null)
            "
          >
            <span class="exception-txt">
              ページの見出しタグを取得中です。
            </span>
          </template>
          <template
            v-else-if="
              !item.headerStructures || item.headerStructures.length === 0
            "
          >
            <div class="exception-txt">
              ページの中に見出しタグはみつかりませんでした。
              <Tooltip variant="attention" position="left-top">
                データの取得ができませんでした。
                原因は対象のサイトでIPアドレスのブロックなどの理由でデータを取得できなかったことが考えられます。
              </Tooltip>
            </div>
          </template>
          <template v-else>
            <ul>
              <ListItemRanksTitleHeaders
                v-for="(header, index) in item.headerStructures"
                :key="index"
                :item="header"
                ref="listItemRanksTitle"
                @displayBtn="displayBtn"
              />
            </ul>
          </template>
        </td>
      </template>
      <template v-else>
        <td>
          <template v-if="item.headers.h1">
            <ul>
              <li v-if="item.headers.h1.length === 0">
                ページの中にh1はみつかりませんでした。
              </li>
              <li v-for="(h1, index) in item.headers.h1" :key="index">
                <template v-if="h1 === null">h1は画像です </template>
                <template v-else>
                  {{ h1 }}
                </template>
              </li>
            </ul>
          </template>
          <template v-else>
            h1を取得中です。
          </template>
        </td>
        <td>
          <template v-if="item.headers.h2">
            <ul>
              <li v-if="item.headers.h2.length === 0">
                ページの中にh2はみつかりませんでした。
              </li>
              <li v-for="(h2, index) in item.headers.h2" :key="index">
                <template v-if="h2 === null">h2は画像です </template>
                <template v-else>
                  {{ h2 }}
                </template>
              </li>
            </ul>
          </template>
          <template v-else>
            h2を取得中です。
          </template>
        </td>
        <td>
          <template v-if="item.headers.h3">
            <ul>
              <li v-if="item.headers.h3.length === 0">
                ページの中にh3はみつかりませんでした。
              </li>
              <li v-for="(h3, index) in item.headers.h3" :key="index">
                <template v-if="h3 === null">h3は画像です </template>
                <template v-else>
                  {{ h3 }}
                </template>
              </li>
            </ul>
          </template>
          <template v-else>
            h3を取得中です。
          </template>
        </td>
      </template>
    </template>
    <template v-else-if="item.contentType === 'pdf'">
      <td class="l-px-0 c-text--center rank cannot-be-analyzed">
        <p v-if="item.isOwnSite" class="own-site">登録サイト</p>
        {{ item.rank }}
      </td>
      <td class="cannot-be-analyzed">
        <a :href="item.url" target="_blank" class="c-link--blank">{{
          item.url
        }}</a>
        <br />
      </td>
      <td class="cannot-be-analyzed">PDFのため分析ができません。</td>
      <template v-if="isAfterHeaderStructuresReleaseDate">
        <td class="cannot-be-analyzed"></td>
        <td class="cannot-be-analyzed"></td>
      </template>
      <template v-else>
        <td class="cannot-be-analyzed"></td>
        <td class="cannot-be-analyzed"></td>
        <td class="cannot-be-analyzed"></td>
        <td class="cannot-be-analyzed"></td>
      </template>
    </template>
    <template v-else-if="!item.url && item.isOwnSite">
      <td class="l-px-0 c-text--center rank cannot-be-analyzed">
        <p class="own-site">登録サイト</p>
        圏外
      </td>
      <td class="cannot-be-analyzed"></td>
      <td class="cannot-be-analyzed">
        100位以内に登録サイトのデータが存在しません。
      </td>
      <td class="cannot-be-analyzed"></td>
      <template v-if="isAfterHeaderStructuresReleaseDate">
        <td class="structures cannot-be-analyzed"></td>
      </template>
      <template v-else>
        <td class="cannot-be-analyzed"></td>
        <td class="cannot-be-analyzed"></td>
        <td class="cannot-be-analyzed"></td>
      </template>
    </template>
  </tr>
</template>
<script>
import { INTENT_TYPES } from '@/constants';
import ListItemRanksTitleHeaders from '@/components/contentPlans/ListItemRanksTitleHeaders';
import Checkbox from '@/components/Checkbox';
import Tooltip from '@/components/Tooltip';
import { MAX_TDH_STRING_LENGTH } from '@/constants';

export default {
  props: [
    'item',
    'project',
    'index',
    'isAfterHeaderStructuresReleaseDate',
    'isActiveAll',
    'checked',
    'checkedNow'
  ],

  components: {
    Checkbox,
    ListItemRanksTitleHeaders,
    Tooltip
  },

  computed: {
    intent() {
      if (this.item.intent && this.item.intent.label) {
        return INTENT_TYPES[this.item.intent.label];
      }
      return null;
    },
    showUnknownTooltip() {
      if (this.item.intent.label === INTENT_TYPES.unknown.name) {
        return true;
      }
      return false;
    },
    isChecked() {
      return (
        this.isActiveAll ||
        this.checkedNow.some(rank => rank === this.item.rank)
      );
    },
    checkBoxId() {
      return 'serps_' + String(this.index + 1);
    },
    isOverTitleMaxLength() {
      if (this.item.title) {
        return this.item.title.length > MAX_TDH_STRING_LENGTH;
      }
      return false;
    },
    isOverDescriptionMaxLength() {
      if (this.item.description) {
        return this.item.description.length > MAX_TDH_STRING_LENGTH;
      }
      return false;
    },
    MAX_TDH_STRING_LENGTH() {
      return MAX_TDH_STRING_LENGTH;
    }
  },

  data() {
    return {
      isBtn: false
    };
  },

  methods: {
    change(checked) {
      this.$emit('check', checked);
    },
    toggleChildrenAll(e) {
      for (let i = 0; i < this.$refs.listItemRanksTitle.length; i++) {
        if (!e.target.classList.contains('open')) {
          this.$refs.listItemRanksTitle[i].toggleChildrenAll(true);
        } else {
          this.$refs.listItemRanksTitle[i].toggleChildrenAll(false);
        }
      }

      if (!e.target.classList.contains('open')) {
        e.target.classList.add('open');
        e.target.innerText = '表示を戻す';
      } else {
        e.target.classList.remove('open');
        e.target.innerText = '構造をすべて表示';
      }
    },
    displayBtn() {
      this.isBtn = true;
    },
    checkTd() {
      this.$refs.checkbox.change();
    }
  }
};
</script>
